import * as React from 'react';
import styled from '@emotion/styled';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SearchIcon from '@mui/icons-material/Search';
import { NavLink } from 'react-router-dom';
import StyledToolTips from '../../../utils/tooltip/StyledToolTip';
import { usePrimaryEffectEnhancement } from '../../../style/global/theme';
import { useProvideAuth } from '../../../utils/authentication/use-Auth';

const StyledSidebar = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: #eeeeee;
  padding: 1rem 0;
`;

const StyledIcons = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledLink = styled(NavLink)`
  margin-bottom: 1rem;
`;

const IconsStyle = {
  fontSize: 40,
  color: '#4B286D',
  margin: '1rem',
};

const Sidebar = () => {
  const EnhancedIconStyle = usePrimaryEffectEnhancement(IconsStyle);
  const { user } = useProvideAuth();

  return (
    <StyledSidebar>
      <StyledIcons>
        <StyledLink to="search">
          <StyledToolTips title="Search" enterDelay={100}>
            <SearchIcon sx={EnhancedIconStyle} />
          </StyledToolTips>
        </StyledLink>
        {user?.[`${process.env.REACT_APP_METADATA_FOR_ROLES}/roles`]?.[0] === 'admin' && (
          <StyledLink to="uploadFile">
            <StyledToolTips title="UploadFile" enterDelay={100} arrow>
              <UploadFileIcon sx={EnhancedIconStyle} />
            </StyledToolTips>
          </StyledLink>
        )}
      </StyledIcons>
    </StyledSidebar>
  );
};

export default Sidebar;
